import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, MessageCircle, Calendar, ArrowLeft } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/pAUUzwkew5M2Jdo9P6J2GU/ChatGPT_Image_9_abr_2026,_04_58_39_p.m..png';
interface WhatsAppConfirmationModalProps {
  formData: {
    age: string;
    goal: string;
    state: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
  };
  onConfirm: () => void;
  onClose: () => void;
}
type ModalView = 'options' | 'calendar' | 'whatsapp';
export function WhatsAppConfirmationModal({
  formData,
  onConfirm,
  onClose
}: WhatsAppConfirmationModalProps) {
  const [currentView, setCurrentView] = useState<ModalView>('options');
  const whatsappMessage = `Hola! Acabo de completar el formulario de Life Freedom.

📋 Mis datos:
- Nombre: ${formData.firstName} ${formData.lastName}
- Edad: ${formData.age}
- Objetivo: ${formData.goal}
- Estado: ${formData.state}
- Teléfono: ${formData.phone}
- Email: ${formData.email}

Me gustaría continuar la conversación.`;
  const handleBack = () => {
    setCurrentView('options');
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-3 bg-black/60" onClick={onClose} data-id="element-275">
      <motion.div initial={{
      scale: 0.95,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.95,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className={`bg-white rounded-2xl w-full overflow-hidden shadow-2xl flex flex-col ${currentView === 'calendar' ? 'max-w-4xl max-h-[95vh]' : 'max-w-md max-h-[85vh]'}`} onClick={e => e.stopPropagation()} data-id="element-276">
        {/* Header */}
        <div className="relative bg-gradient-to-br from-primary to-primary-hover p-3 text-white flex-shrink-0" data-id="element-277">
          <button onClick={onClose} className="absolute top-2 right-2 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Cerrar" data-id="element-278">
            <X className="w-4 h-4" data-id="element-279" />
          </button>
          {currentView !== 'options' && <button onClick={handleBack} className="absolute top-2 left-2 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Volver" data-id="element-280">
              <ArrowLeft className="w-4 h-4" data-id="element-281" />
            </button>}
          <div className="flex justify-center mb-2" data-id="element-282">
            <img src={LOGO_URL} alt="Life Freedom" className="h-12 object-contain" data-id="element-283" />
          </div>
          <h2 className="text-sm font-bold text-center" data-id="element-284">
            {currentView === 'options' && '¿Cómo Prefieres Continuar?'}
            {currentView === 'calendar' && 'Agenda Tu Cita'}
            {currentView === 'whatsapp' && 'Vista Previa del Mensaje'}
          </h2>
        </div>

        {/* Content */}
        <AnimatePresence mode="wait" data-id="element-285">
          {currentView === 'options' && <motion.div key="options" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 20
        }} className="p-4 flex-1 overflow-y-auto" data-id="element-286">
              <p className="text-sm text-gray-600 text-center mb-4" data-id="element-287">
                Elige cómo te gustaría dar el siguiente paso
              </p>

              <div className="space-y-3" data-id="element-288">
                {/* Calendar Option */}
                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={() => setCurrentView('calendar')} className="w-full bg-gradient-to-r from-primary to-primary-hover text-white p-4 rounded-xl shadow-lg transition-all duration-200 flex items-center gap-3" data-id="element-289">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-290">
                    <Calendar className="w-6 h-6" data-id="element-291" />
                  </div>
                  <div className="flex-1 text-left" data-id="element-292">
                    <p className="font-bold text-base" data-id="element-293">Agendar una Cita</p>
                    <p className="text-xs text-white/90" data-id="element-294">
                      Elige fecha y hora que te convenga
                    </p>
                  </div>
                </motion.button>

                {/* WhatsApp Option */}
                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={() => setCurrentView('whatsapp')} className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 rounded-xl shadow-lg transition-all duration-200 flex items-center gap-3" data-id="element-295">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-296">
                    <MessageCircle className="w-6 h-6" data-id="element-297" />
                  </div>
                  <div className="flex-1 text-left" data-id="element-298">
                    <p className="font-bold text-base" data-id="element-299">
                      Continuar por WhatsApp
                    </p>
                    <p className="text-xs text-white/90" data-id="element-300">
                      Chatea directamente con un asesor
                    </p>
                  </div>
                </motion.button>
              </div>

              <div className="mt-4 bg-blue-50 rounded-lg p-3 border border-blue-100" data-id="element-301">
                <p className="text-xs text-blue-800 text-center leading-tight" data-id="element-302">
                  💡 Ambas opciones son gratuitas y sin compromiso
                </p>
              </div>
            </motion.div>}

          {currentView === 'calendar' && <motion.div key="calendar" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 20
        }} className="flex-1 overflow-hidden flex flex-col min-h-[600px]" data-id="element-303">
              <div className="flex-1 overflow-hidden" data-id="element-304">
                <iframe src="https://api.leadconnectorhq.com/widget/bookings/celndario-grupal" className="w-full h-full border-0 min-h-[600px]" title="Calendario de Citas" data-id="element-305" />
              </div>
              <div className="p-3 bg-gray-50 border-t border-gray-200 flex-shrink-0" data-id="element-306">
                <p className="text-xs text-gray-600 text-center" data-id="element-307">
                  Selecciona la fecha y hora que mejor te convenga
                </p>
              </div>
            </motion.div>}

          {currentView === 'whatsapp' && <motion.div key="whatsapp" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 20
        }} className="flex-1 overflow-y-auto flex flex-col" data-id="element-308">
              <div className="p-3 flex-1 overflow-y-auto" data-id="element-309">
                <div className="bg-gray-50 rounded-lg p-2.5 border border-gray-200" data-id="element-310">
                  <div className="flex items-start gap-2" data-id="element-311">
                    <div className="w-8 h-8 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-312">
                      <MessageCircle className="w-4 h-4 text-white" data-id="element-313" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-314">
                      <p className="text-[10px] text-gray-500 mb-1" data-id="element-315">
                        Mensaje para WhatsApp
                      </p>
                      <div className="bg-white rounded-lg p-2 shadow-sm border border-gray-100" data-id="element-316">
                        <pre className="text-[11px] text-dark whitespace-pre-wrap font-sans leading-relaxed" data-id="element-317">
                          {whatsappMessage}
                        </pre>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-2 bg-blue-50 rounded-lg p-2 border border-blue-100" data-id="element-318">
                  <p className="text-[10px] text-blue-800 text-center leading-tight" data-id="element-319">
                    Al confirmar, enviaremos tu información y abriremos WhatsApp
                  </p>
                </div>
              </div>

              <div className="p-3 pt-0 flex-shrink-0" data-id="element-320">
                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={onConfirm} className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white font-bold text-sm py-3 px-4 rounded-xl shadow-lg transition-all duration-200 flex items-center justify-center gap-2" data-id="element-321">
                  <MessageCircle className="w-5 h-5" data-id="element-322" />
                  Enviar y Seguir por WhatsApp
                </motion.button>
              </div>
            </motion.div>}
        </AnimatePresence>
      </motion.div>
    </motion.div>;
}